import { DefaultTheme } from 'styled-components'

import theme from './theme'

export const up = (breakpointName: keyof DefaultTheme['breakpoints']) => {
  const breakpoint = theme.breakpoints[breakpointName]
  if (!breakpoint) {
    throw new Error('Breakpoint is not defined!')
  }
  return `@media (min-width: ${breakpoint})`
}

export const down = (breakpointName: keyof DefaultTheme['breakpoints']) => {
  const breakpoint = theme.breakpoints[breakpointName]
  if (!breakpoint) {
    throw new Error('Breakpoint is not defined!')
  }
  return `@media (max-width: ${breakpoint})`
}

export const between = (minName: keyof DefaultTheme['breakpoints'], maxName: keyof DefaultTheme['breakpoints']) => {
  const minBreakpoint = theme.breakpoints[minName]
  const maxBreakpoint = theme.breakpoints[maxName]
  if (!minBreakpoint || !maxBreakpoint) {
    throw new Error('Breakpoint is not defined!')
  }
  return `@media (min-width: ${minBreakpoint}) and (max-width: ${maxBreakpoint})`
}
